import { StateProvider, StateService } from "@uirouter/angularjs";
import { IServiceProvider } from "angular";
import { UserProfile } from "../../../../application/UserProfile";
import {
  ITabConfig,
  ITabStateConfig,
  MachineDetailTabsService,
  vsServiceName as machineDetailTabsServiceName,
} from "./machineDetailTabsService";

export const vsProviderName = `${machineDetailTabsServiceName}Provider`;

export class MachineDetailTabsProvider implements IServiceProvider {
  static $inject = ["$stateProvider"];
  private readonly _tabs: ITabConfig[] = [];

  constructor(private readonly $stateProvider: StateProvider) {}

  addTabConfig(config: ITabConfig) {
    this._tabs.push(config);
    this.registerState(config, MachineDetailTabsService.basePath);
  }

  $get: any = [
    "userProfile",
    "$state",
    (userProfile: UserProfile, $state: StateService) => {
      return new MachineDetailTabsService(userProfile, this._tabs, $state);
    },
  ];

  private registerState(tab: ITabStateConfig, basePath: string) {
    const path = `${basePath}.${tab.uiSrefFragment}`;
    this.$stateProvider.state(path, tab.stateDefinition);
    tab.children?.forEach((c) => {
      this.registerState(c, path);
    });
  }
}
